import React, { useState, useEffect } from 'react';
import BusinessCard from './BusinessCard';

/**
 * Business Filter Component
 * Filters businesses by: all, exclusive offers, or resources
 * Sorts alphabetically when showing all
 */
export default function BusinessFilter({ businesses, locations, analytics }) {
  const [activeFilter, setActiveFilter] = useState('all');
  const [filteredBusinesses, setFilteredBusinesses] = useState([]);
  const [counts, setCounts] = useState({ all: 0, exclusive: 0, resource: 0, popup: 0 });

  useEffect(() => {
    // Count businesses by category
    const allCount = businesses.length;
    const exclusiveCount = businesses.filter(b => b.hasExclusive).length;
    const resourceCount = businesses.filter(b => b.isResource).length;
    const popupCount = businesses.filter(b => b.hasPopup).length;

    setCounts({ all: allCount, exclusive: exclusiveCount, resource: resourceCount, popup: popupCount });

    // Apply current filter
    let filtered = [...businesses];

    if (activeFilter === 'exclusive') {
      filtered = businesses.filter(b => b.hasExclusive);
    } else if (activeFilter === 'resource') {
      filtered = businesses.filter(b => b.isResource);
    } else if (activeFilter === 'popup') {
      filtered = businesses.filter(b => b.hasPopup);
    } else if (activeFilter === 'all') {
      // Sort alphabetically when showing all
      filtered.sort((a, b) => a.title.localeCompare(b.title));
    }

    setFilteredBusinesses(filtered);
  }, [businesses, activeFilter]);

  const handleFilterChange = (filterId) => {
    setActiveFilter(filterId);
    if (analytics) {
      analytics.trackInteraction('filter_businesses', { filter: filterId });
    }
  };

  const tabs = [
    { id: 'all', label: 'All', count: counts.all },
    { id: 'exclusive', label: 'Offers', count: counts.exclusive },
    { id: 'popup', label: 'Popups', count: counts.popup },
    { id: 'resource', label: 'Nonprofits', count: counts.resource },
  ];

  return (
    <div>
      {/* Filter tabs — Bluesky-style pills */}
      <div className="feed-tabs mb-6">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => handleFilterChange(tab.id)}
            className={`tab-pill ${activeFilter === tab.id ? 'tab-pill--active' : 'tab-pill--inactive'}`}
            data-filter={tab.id}
          >
            {tab.label}
            <span className={activeFilter === tab.id ? 'text-pink-100' : 'text-gray-400'}>({tab.count})</span>
          </button>
        ))}
      </div>

      {/* No businesses message */}
      {filteredBusinesses.length === 0 && (
        <div className="post text-center py-12">
          <p className="text-gray-600">No businesses found for this filter.</p>
        </div>
      )}

      {/* Business post tiles grid */}
      {filteredBusinesses.length > 0 && (
        <div className="space-y-5">
          {filteredBusinesses.map(business => {
            const location = locations.find(l => l.id === business.locationId);
            return (
              <BusinessCard
                key={business.id}
                business={business}
                location={location}
                analytics={analytics}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
